const AUTH_TOKEN_KEY = 'diya_visitor_token';
const AUTH_USER_KEY = 'diya_user';
const AUTH_INFO_KEY = 'diya_visitor';

export function getAuthToken() {
  try {
    return (localStorage.getItem(AUTH_TOKEN_KEY) || '').trim();
  } catch (e) {
    return '';
  }
}

/** @deprecated 兼容旧名 */
export function getVisitorToken() {
  return getAuthToken();
}

export function saveAuthSession(data) {
  if (!data) return;
  if (data.token) {
    localStorage.setItem(AUTH_TOKEN_KEY, String(data.token).trim());
  }
  if (data.user) {
    localStorage.setItem(AUTH_USER_KEY, JSON.stringify(data.user));
  }
  localStorage.setItem(
    AUTH_INFO_KEY,
    JSON.stringify({
      username: (data.user && data.user.username) || '',
      passwordLogin: true,
    })
  );
}

/** @deprecated 兼容旧名 */
export function saveVisitorSession(data) {
  saveAuthSession(data);
}

export function clearAuthSession() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_INFO_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  localStorage.removeItem('diya_session_token');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
}

export function clearVisitorSession() {
  clearAuthSession();
}

export function getAuthUser() {
  try {
    const raw = localStorage.getItem(AUTH_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function getVisitorInfo() {
  try {
    const raw = localStorage.getItem(AUTH_INFO_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function isLoggedIn() {
  return !!getAuthToken();
}

/** @deprecated 兼容旧名 */
export function isVisitorLoggedIn() {
  return isLoggedIn();
}
